<template>
  <div class="login">
    <SmsCode></SmsCode>
  </div>
</template>

<script>
import SmsCode from "./smsCode";
export default {
  data() {
    return {};
  },
  components: {
    SmsCode,
  },
  methods: {},
};
</script>

<style lang="less" scoped></style>
